export class ActivityType {
    name:string=""
    formData(){
        let body = new URLSearchParams();
        body.set('name', this.name);
        return body.toString()
      }
}
